module.exports = __webpack_public_path__ + "img/card-bg.05d160ea.png";